// extracted by mini-css-extract-plugin
export default {"container":"ProductDetailTab_container__AZ2y1","viewLine":"ProductDetailTab_viewLine__hQXKD"};